import mutations from './eprofileAllergia.mutations'
import actions from './eprofileAllergia.actions'
import getters from './eprofileAllergia.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
